export enum StatusWorkflowEnum {
    APPROVED = "Aprovado",
    CANCELED = "Cancelado",
    // eslint-disable-next-line sonarjs/no-duplicate-string
    WAITING_APPROVAL = "Aguardando aprovação",
}

export enum ActionTakenEnum {
    CREATION = "Criado",
    EXCLUSION = "Excluído",
}

export enum StatusActivityPlanEnum {
    SKETCH = "Rascunho",
    WAITING_APPROVAL = "Aguardando aprovação",
    APPROVED = "Aprovado",
    DISAPPROVED = "Indeferido",
    FINISHED = "Finalizado",
    INCONSISTENT = "Inconsistente",
}

export enum AllowanceStatusEnum {
    APPROVED = "Deferido",
    DISAPPROVED = "Indeferido",
    WAITING_APPROVAL = "Em Aprovação",
}

export enum StatusTachProcess {
    CANCELED = "Cancelado",
    WAITING_APPROVAL = "Aguardando aprovação",
    PENDING = "Pendente",
    DONE = "Aprovado",
}

type EnumNumberValues =
    | "Aprovado"
    | "Aguardando aprovação"
    | "Rascunho"
    | "Indeferido"
    | "Finalizado"
    | "Inconsistente"
    | "Deferido"
    | "Em Aprovação";

export const getEnumReportNumberValue = (value: any) => {
    const choosenValue = value
        .filter((i: any) => i.add)
        .map((i: any) => i.name)
        .join(", ");
    const item = choosenValue as EnumNumberValues;
    const enumValue = {
        Rascunho: 1,
        "Aguardando aprovação": 2,
        "Em Aprovação": 2,
        Aprovado: 3,
        Deferido: 3,
        Indeferido: 4,
        Finalizado: 5,
        Inconsistente: 6,
    };
    return enumValue[item] || null;
};

export const getEnumListReportNumberValues = (value: any[]) => {
    const enumValue = {
        Rascunho: 1,
        "Aguardando aprovação": 2,
        "Em Aprovação": 2,
        Aprovado: 3,
        Deferido: 3,
        Indeferido: 4,
        Finalizado: 5,
        Inconsistente: 6,
    };

    return value
        .filter((item) => item.add === true)
        .map((item) => {
            const itemName = item.name;
            const teste = itemName as EnumNumberValues;
            if (enumValue[teste]) {
                return enumValue[teste];
            }
            return null;
        });
};

type EnumStringValues =
    | "Aguardando aprovação"
    | "Aprovado"
    | "Cancelado"
    | "Pendente"
    | "Excluído"
    | "Criado";

export const getEnumProcessStringValue = (value: any) => {
    const choosenValue = value
        .filter((i: any) => i.add)
        .map((i: any) => i.name)
        .join(", ");
    const item = choosenValue as EnumStringValues;
    const enumValue = {
        "Aguardando aprovação": "WAITING_APPROVAL",
        Aprovado: "DONE",
        Cancelado: "CANCELED",
        Pendente: "PENDING",
        Excluído: "EXCLUSION",
        Criado: "CREATION",
    };

    return enumValue[item] || null;
};
